import React from 'react';
import { ImgUploaderForStyleSettings } from 'components/ImgUploader/ImgUploaderForStyleSettings';
import style from './ThumbItem.module.scss';

interface IProps {
	onClick: () => void;
	selected: boolean;
	isMakeRequest: boolean;
	translationId: string;
	filePath?: Nullable<string>;
}

export const ThumbImgItem: React.FC<IProps> = React.memo(
	({ onClick, selected, isMakeRequest, translationId, filePath = null }) => (
		<div className={`${style.emblaSlide} ${style.emblaSlideThumb} ${selected ? style.isSelected : ''}`}>
			<button
				onClick={onClick}
				className={`${style.emblaSlideInner} ${style.emblaSlideInnerThumb}`}
				type="button">
				<span className={style.emblaSlideThumbnailDiv}>
					<ImgUploaderForStyleSettings
						translationID={translationId}
						photoSize="Small"
						isMakeImageRequest={isMakeRequest}
						loaderSize="big"
						noImageIdIcon="twoHills"
						filePath={selected ? filePath : null}
						isUseInSlider={true}
					/>
				</span>
			</button>
		</div>
	),
);
